import { GetMedicalDeviceInfoUrlUsecase } from "@/domain/usecase/common/footer/get-medical-device-info-url-usecase";
import { GetPrivacyPolicyUrlUsecase } from "@/domain/usecase/common/footer/get-privacy-policy-url-usecase";
import { GetTermsOfServiceUrlUsecase } from "@/domain/usecase/common/footer/get-terms-of-service-url-usecase";
import { getRoleFromPath, UserRole } from "@/utils/enum/user-role";
import { EXCLUDE_FOOTER_PATH } from "@/utils/global-constants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";

interface FooterViewModelDependencies {
  getMedicalDeviceInfoUrlUsecase: GetMedicalDeviceInfoUrlUsecase;
  getPrivacyPolicyUrlUsecase: GetPrivacyPolicyUrlUsecase;
  getTermsOfServiceUrlUsecase: GetTermsOfServiceUrlUsecase;
}

export const useFooterViewModel = (dependencies: FooterViewModelDependencies) => {
  const location = useLocation();
  const pathname = location.pathname;
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [medicalDeviceInfoPath, setMedicalDeviceInfoPath] =
    useState<string>("/medical-device-info");
  const [privacyPolicyUrl, setPrivacyPolicyUrl] = useState<string>("");
  const [termsOfServiceUrl, setTermsOfServiceUrl] = useState<string>("");

  // React Compiler가 자동으로 최적화
  const isExcluded = EXCLUDE_FOOTER_PATH.some((path) => pathname.includes(path));

  useEffect(() => {
    const role = getRoleFromPath(pathname);
    const medicalDeviceUrl = dependencies.getMedicalDeviceInfoUrlUsecase.execute(role);
    const privacyUrl = dependencies.getPrivacyPolicyUrlUsecase.execute();
    const termsUrl = dependencies.getTermsOfServiceUrlUsecase.execute();

    setMedicalDeviceInfoPath(medicalDeviceUrl);
    setPrivacyPolicyUrl(privacyUrl);
    setTermsOfServiceUrl(termsUrl);
    // 사용자가 언어를 변경하면 약관/개인정보 처리방침 링크도 해당 언어로 갱신한다.
  }, [pathname, dependencies, currentLanguage]);

  return {
    isExcluded,
    medicalDeviceInfoPath,
    privacyPolicyUrl,
    termsOfServiceUrl,
  };
};
